module.exports = __webpack_public_path__ + "static/2-layer2-d3c8a4108e43eb15f10fe0991401c036.svg";